export const customerStatusIds = {
  active: '98124f87-04aa-49a9-bc8c-1a185ab47da0',
  inactive: '126ea846-35f8-4f8b-b41b-671a4af51e1a'
};
